import * as React from "react";
import StoreHours from "../store-hours";
export default class DescDefault extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let supplier = this.props.supplier;
        let province = supplier.Province ? supplier.Province.toUpperCase() : null;
        let postal = supplier.PostalCode ? supplier.PostalCode.toUpperCase() : null;
        return (React.createElement("div", { className: "store-template-b__contact" },
            React.createElement("a", { "data-name": "contact" }),
            React.createElement("div", { className: "store-template-b__contact__wrap" },
                React.createElement("h2", null, "Contact & Hours"),
                React.createElement("div", { className: "store-template-b__contact__columns" },
                    React.createElement("div", { className: "store-template-b__contact__columns__col" },
                        React.createElement("h5", null, "Address"),
                        React.createElement("p", null,
                            supplier.StreetAddress,
                            React.createElement("br", null),
                            supplier.City,
                            ", ",
                            province,
                            " ",
                            postal),
                        React.createElement("div", null,
                            React.createElement("h5", null, "Hours"),
                            React.createElement(StoreHours, { supplier: this.props.supplier }),
                            React.createElement("p", null))),
                    React.createElement("div", { className: "store-template-b__contact__columns__col" },
                        React.createElement("h5", null, "Phone"),
                        React.createElement("p", null,
                            React.createElement("a", { href: `tel:{supplier.Phone}` }, supplier.Phone)),
                        supplier.Email &&
                            React.createElement("div", null,
                                React.createElement("h5", null, "Email"),
                                React.createElement("p", null, supplier.Email)),
                        supplier.PaymentMethods &&
                            React.createElement("div", null,
                                React.createElement("h5", null, "Payment Methods"),
                                React.createElement("p", null,
                                    "We accept ",
                                    supplier.PaymentMethods,
                                    ".")),
                        supplier.EstablishmentType &&
                            React.createElement("div", null,
                                React.createElement("h5", null, "Establishment Type"),
                                React.createElement("p", null, supplier.EstablishmentType))))),
            supplier.Website &&
                React.createElement("div", { className: "store-template-b__contact__footer" },
                    React.createElement("a", { href: supplier.Website, className: "btn-template-b", target: "_blank" },
                        "Visit ",
                        supplier.Name,
                        " Website"))));
    }
}
;
//# sourceMappingURL=contact.js.map